import { render, staticRenderFns } from "./Rightvideo.vue?vue&type=template&id=246c6aee"
import script from "./Rightvideo.vue?vue&type=script&lang=js"
export * from "./Rightvideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports